module.exports = __webpack_public_path__ + "img/folder.f5507db8.svg";